import React from "react";
import { MemberSuggester } from "../MemberSuggester/MemberSuggester";
export const MemberSuggesterPluginView = ({ view, suggesterCallbacksRegistry, mentionService, onPublicProfileOpen, }) => {
    return (React.createElement(MemberSuggester, { view: view, suggesterCallbacksRegistry: suggesterCallbacksRegistry, mentionService: mentionService, onPublicProfileOpen: onPublicProfileOpen }));
};
